// extracted by mini-css-extract-plugin
export default {"title":"SidePageFormTitle-module--title--vIWpt"};